/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React from 'react';

interface IHelperProps {
    children: any
}

const FormElementHelper = ({ children }: IHelperProps) => (
    <small className="d-block text-gray">{children}</small>
);

export default FormElementHelper;
